export default {
  existingAccount:
    'Es sieht so aus, als hättest du bereits ein Konto bei uns, willkommen zurück! Bitte logge dich wieder ein und setze dein Passwort zurück, falls du es benötigst.',
}
